// A genesis `File` (mimeType + base64 content) as an <img src>, decided once.
//
// A data: URI AND NEVER A URL. The BFF's CSP admits images from self, data: and blob: only, and the
// blob store's own origin is not among them, so a src pointing at it would fail silently and leave
// a broken frame where the image should be. That is why the bytes travel base64 inside the GraphQL
// response at all.
//
// BOTH HALVES HAVE TO BE PRESENT. Half an image would render as a broken frame on a page anybody
// may read, so it is never built and the caller falls back to whatever it draws for "no image".
// This guards the type, not a state that is expected to occur.
//
// The company logo (pages/company/company-logo.ts) and the branding logo (lib/use-brand-logo.ts)
// share this one rule; the CV prefill and the questionnaire-group artwork still carry their own
// copies of it (spark#314 names that as a separate clean-up).

export interface ImageValue {
  mimeType?: string | null;
  content?: string | null;
}

/** The data: URI for a stored image, or null when there is nothing to render. */
export function imageDataUrl(image: ImageValue | null | undefined): string | null {
  return image?.content && image.mimeType
    ? `data:${image.mimeType};base64,${image.content}`
    : null;
}
